import { call, put, takeLatest } from 'typed-redux-saga'
import { leadApi, LeadTotalNS, leadTotalSlice } from 'Pages/lead'
import { errorHandler } from 'Modules'

export function* getTotalConsentWait(action: LeadTotalNS.GetTotalConsentWait) {
	try {
		const res = yield* call(leadApi.getTotalConsentWait)
		yield* put(leadTotalSlice.actions.setTotalConsentWait(res?.total_entries))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* getTotalNoOrders(action: LeadTotalNS.GetTotalNoOrders) {
	try {
		const res = yield* call(leadApi.getTotalNoOrders)
		yield* put(leadTotalSlice.actions.setTotalNoOrders(res?.total_entries))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* leadTotalSaga() {
	yield* takeLatest(leadTotalSlice.actions.getTotalConsentWait, getTotalConsentWait)
	yield* takeLatest(leadTotalSlice.actions.getTotalNoOrders.type, getTotalNoOrders)
}
